// tslint:disable
import React from 'react'

interface IProps {
    style?: React.CSSProperties
    onClick: (e: React.MouseEvent<HTMLLabelElement, MouseEvent>) => void
    inkColor?: string
    className?: string
    tagName?: string
}

const inkwellDomQueue: Set<HTMLElement> = new Set()

class InkWellComp extends React.Component<IProps, {}> {
    private inkWellRef: React.RefObject<HTMLLabelElement>
    // private

    constructor(props: IProps) {
        super(props)
        this.inkWellRef = React.createRef<HTMLLabelElement>()
    }

    public onClick = (e: any) => {
        // playClickMedia()
        this.props.onClick(e)
    }

    public onMouseDownEvent = (e: any) => {
        this.onPointerDown(e)
    }

    public onMouseUpEvent = (e: any) => {
        this.onPointerUp(e)
    }

    public onTouchStartEvent = (e: any) => {
        this.onPointerDown(e)
    }

    public onTouchEndEvent = (e: any) => {
        this.onPointerUp(e)
    }

    public render() {
        // const classes = this.props.classes

        return React.createElement(
            this.props.tagName || 'label',
            {
                ...this.props,
                className: this.props.className,
                style: Object.assign(
                    {},
                    {
                        overflow: 'hidden',
                        position: 'relative',
                    },
                    this.props.style,
                ),
                onClick: this.onClick,
                ref: this.inkWellRef,
                onMouseDown: this.onMouseDownEvent,
                onMouseUp: this.onMouseUpEvent,
                onTouchStart: this.onTouchStartEvent,
                onTouchEnd: this.onTouchEndEvent,
            },
            [this.props.children],
        )
    }

    private onPointerDown(e: React.TouchEvent | React.MouseEvent) {
        // if (isAndroid) return
        if (inkwellDomQueue.size >= 3) {
            return
        }
        e.persist()
        let pointDownX = 0
        let pointDownY = 0
        if (e.nativeEvent instanceof TouchEvent) {
            const point = e.nativeEvent.touches[0]
            pointDownX = point.pageX
            pointDownY = point.pageY
        } else if (e.nativeEvent instanceof MouseEvent) {
            const point = e.nativeEvent
            pointDownX = (point as MouseEvent).pageX
            pointDownY = (point as MouseEvent).pageY
        }

        if (this.inkWellRef.current) {
            const rect = this.inkWellRef.current.getBoundingClientRect()
            const clientX = pointDownX - rect.left
            const clientY = pointDownY - rect.top
            const i = document.createElement('i')
            i.style.position = 'absolute'
            i.style.top = clientY + 'px'
            i.style.width = '100px'
            i.style.height = '100px'
            i.style.left = clientX + 'px'
            i.style.borderRadius = '50%'
            i.style.background = this.props.inkColor || '#999'
            i.style.opacity = '1'
            i.style.transform = `translate(-${50}px, -${50}px) scale(0)`
            ;(i as any)['opacity'] = 1
            ;(i as any)['speed'] = 1
            ;(i as any)['scale'] = 0

            const compute = () => {
                // const oldWidth = (i as any)['width']
                const oldOpacity = (i as any)['opacity']
                // const oldHeight = (i as any)['height']
                const speed = (i as any)['speed']
                const oldScale = (i as any)['scale']
                // console.log(oldOpacity)
                if (oldOpacity <= 0) {
                    if (this.inkWellRef.current && this.inkWellRef.current.contains(i)) {
                        this.inkWellRef.current.removeChild(i)
                    }
                    inkwellDomQueue.delete(i)

                    return
                }
                // const newWidth = oldWidth + 2 * speed
                // const newHeight = oldHeight + 2 * speed
                const newOpcity = oldOpacity - 0.01 * speed
                const newScale = oldScale + 0.04 * speed
                // (i as any)['width'] = newWidth;
                // (i as any)['height'] = newHeight;
                ;(i as any)['opacity'] = newOpcity
                ;(i as any)['scale'] = newScale
                // i.style.width = newWidth + 'px'
                // i.style.height = newHeight + 'px'
                i.style.opacity = newOpcity + ''
                i.style.transform = 'translate(-50px, -50px) scale(' + newScale + ')'
                window.requestAnimationFrame(compute)
            }

            inkwellDomQueue.add(i)
            this.inkWellRef.current.appendChild(i)
            window.requestAnimationFrame(compute)
        }
    }

    private onPointerUp(e: any) {
        // if (isAndroid) return
        inkwellDomQueue.forEach(value => {
            // tslint:disable-next-line: semicolon
            ;(value as any)['speed'] = 6
        })
    }
}

export const InkWell = InkWellComp
